<template>
  <div :class="`layout layout-${department}`">
    <img
      v-if="department === 'tutor'"
      src="../../public/img/validate-tutor.png"
      alt=""
      style="width:100%;margin-bottom:16px;"
    />
    <div class="bg" v-else-if="department === 'zebra'">
      <p>手机验证，登录查看更多</p>
    </div>
    <img
      v-else
      src="../../public/img/validate.png"
      alt=""
      style="width:100%;margin-bottom:16px;"
    />
    <div class="form-item-wrapper">
      <!-- <garden-icon type="iconshoujihao" class="input-icon"></garden-icon> -->
      <div class="phone"></div>
      <van-field
        v-model="phoneNumber"
        type="tel"
        :placeholder="phoneNumberHolder"
      >
      </van-field>
    </div>
    <div class="form-item-wrapper">
      <!-- <garden-icon type="iconyonghumima" class="input-icon"></garden-icon> -->
      <div class="password"></div>
      <van-field v-model="verification" placeholder="请输入验证码">
        <a-button
          type="link"
          slot="button"
          :style="{ padding: 0, color }"
          @click="checkPhoneNumber"
          class="sms-button"
          :disabled="smsDisabled"
          >{{ btnText }}
        </a-button>
      </van-field>
    </div>
    <div style="margin: 30px 16px">
      <a-button
        type="primary"
        shape="round"
        :disabled="disabled"
        class="confirm-button"
        @click="checkLogin"
      >
        {{ loginBtnText }}
      </a-button>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Encrypt from '@/service/encrypt'
import { genQueryString } from '@/service/url'
const mainDomain =
  location.host.includes('test') || location.host.includes('local')
    ? 'biz'
    : 'com'
export default {
  props: {
    department: String,
  },
  data() {
    return {
      username: '',
      phoneNumber: '',
      verification: '',
      smsCountdown: false,
      btnText: '获取验证码',
      color: '',
      timeout: null,
      loginDisabled: true,
      loginBtnText: '登录',
    }
  },
  computed: {
    smsDisabled() {
      return !this.phoneNumber || this.smsCountdown
    },
    productId() {
      return this.depart === 'tutor' ? '533' : '376'
    },
    queryDefault() {
      return `_hostProductId=${this.productId}&_productId=${
        this.productId
      }&timestamp=${Math.ceil(Date.now() / 1000)}`
    },
    verifierUrl() {
      return `https://ape-api.yuanfudao.${mainDomain}/verifier/api/sms?${
        this.queryDefault
      }`
    },
    loginUrl() {
      return `https://m.yuanfudao.${mainDomain}/tutor-ytk-account/accounts/api/login?${
        this.queryDefault
      }`
    },
    phoneNumberHolder() {
      const { service } = this.$route.query
      return service && service.includes('trainConfirm')
        ? '请使用收到面试邀约的手机号'
        : '请输入手机号'
    },
    disabled() {
      return !(
        /^1\d{10}$/.test(this.phoneNumber) &&
        /^\d{4,6}$/.test(this.verification)
      )
    },
  },
  created() {},
  beforeDestroy() {
    if (this.endCountdownTime === 0 && this.cancel) {
      this.cancel()
      this.cancel = undefined
    }
    clearTimeout(this.timeout)
  },
  methods: {
    checkPhoneNumber() {
      if (!this.phoneNumber) {
        this.$toast('请输入手机号')
      } else if (!/^1\d{10}$/.test(this.phoneNumber)) {
        this.$toast('请输入正确的手机号')
      } else {
        this.sendSms()
      }
    },
    sendSms() {
      this.smsCountdown = true
      this.btnText = '正在发送…'
      axios
        .post(
          this.verifierUrl,
          genQueryString({
            // cancelToken: new CancelToken(c => (this.cancel = c)),
            phone: Encrypt.produce(this.phoneNumber),
          }),
        )
        .then(() => {
          this.$toast('验证码已发送')
          this.endCountdownTime = Date.now() + 59 * 1000
          this.countdown()
        })
        .catch(() => {
          this.$toast('验证码发送失败')
          this.smsCountdown = false
          this.btnText = '重新发送'
        })
    },
    countdown() {
      const sec = Math.ceil((this.endCountdownTime - Date.now()) / 1000)
      if (sec > 0) {
        this.color = '#666'
        this.btnText = `${sec}s`
        this.timeout = window.setTimeout(this.countdown, 1000)
      } else {
        this.color = ''
        this.smsCountdown = false
        this.btnText = '重新发送'
      }
    },
    checkLogin() {
      this.$emit('submitClick')
      let msg = ''
      if (!this.phoneNumber) {
        msg = '请输入手机号'
      } else if (!/^1\d{10}$/.test(this.phoneNumber)) {
        msg = '请输入正确的手机号'
      } else if (!this.verification) {
        msg = '请输入验证码'
      } else if (!/^\d{4,6}$/.test(this.verification)) {
        msg = '请输入正确的验证码'
      } else {
        this.login()
      }
      if (msg) {
        this.$toast(msg)
        return true
      }
    },
    loginErrorHandler(error) {
      let msg = '手机号或验证码错误'
      switch (error.response.status) {
        case 401:
          msg = '验证码输入错误'
          break
        case 403:
          msg = '操作过于频繁,请10分钟后再试'
          break
        case 404:
          msg = '该手机号尚未注册，请切换至短信验证码登录'
          break
        case 408:
          msg = '验证码已失效,请重新获取'
          break
        case 412:
          msg = '该手机尚未设置密码，请切换至短信验证码登录'
      }
      this.$toast(msg)
    },
    login() {
      const formData = {
        phone: Encrypt.produce(this.phoneNumber.trim()),
        verification: Encrypt.produce(this.verification),
      }
      this.loginDisabled = true
      this.loginBtnText = '验证中...'

      axios
        .post(this.loginUrl, genQueryString(formData))
        .then(this.loginSuccess)
        .catch(this.loginErrorHandler)
        .finally(() => {
          this.loginBtnText = '登录'
          this.loginDisabled = false
        })
    },
    async loginSuccess() {
      const { service } = this.$route.query
      const isLegalService =
        service.startsWith('https://garden.yuanfudao.com/') ||
        service.startsWith('http://garden.yuanfudao.com/')
      if (isLegalService) {
        this.$emit('loginSuccess')
        location.replace(decodeURIComponent(service))
      }
    },
  },
}
</script>
<style lang="less">
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset;
}
.layout {
  .van-field__control {
    font-size: 16px;
  }
  .van-cell {
    padding: 10px 10px 10px 15px;
  }
  .ant-btn-primary {
    box-shadow: none;
    text-shadow: none;
  }
}
</style>
<style lang="less" scoped>
@import '~@style/common.less';

.layout {
  max-width: 768px;
  margin: 0 auto;
  height: 100vh;
}
.phone {
  background-image: url('../assets/phone.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 18px;
  height: 18px;
}
.password {
  background-image: url('../assets/password.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 18px;
  height: 18px;
}
.form-item-wrapper {
  position: relative;
  margin: 0 16px;
  padding: 0 10px 0;
  display: flex;
  border-bottom: 1px solid #f0f2f5;
  align-items: center;
  .input-icon {
    color: #cecfd4;
    font-size: 16px;
    width: 40px;
    margin: 0 12px;
    line-height: 44px;
  }
  .form-item {
    // padding-left: 40px;
  }
  .confirm-button {
    background-color: @primary-color;
    border-color: @primary-color;
  }
  .sms-button {
    color: @primary-color;
  }
}
.layout-tutor {
  .confirm-button {
    background-color: @tutor-color;
    border-color: @tutor-color;
  }
  .sms-button {
    color: @tutor-color;
  }
}
.layout-zebra {
  border-top: 1px solid #ebebeb;
  overflow: hidden;
  .form-item-wrapper {
    padding-top: 12px;
    padding-right: 0;
  }
  .bg {
    p {
      color: #333;
      font-size: 20px;
      line-height: 28px;
      margin: 30px auto 33px;
      text-align: center;
      font-weight: bold;
    }
  }
  .confirm-button {
    background-color: @zebra-color;
    border-color: @zebra-color;
  }
  .sms-button {
    color: @zebra-color;
  }
}
</style>
